import { module } from 'modujs';
import Emitter from "tiny-emitter/instance";

export default class extends module {
    constructor(m) {
        super(m);
        this.isOpen = false;

        this.el.addEventListener( 'click', e => {
            e.stopPropagation();
            this.el.closest( this.el.dataset.moduleToggleGroup ).classList.toggle( this.el.dataset.class );
            this.isOpen = ! this.isOpen;
        });
        if( this.el.dataset.clickOutside ){
            this.el.parentNode.addEventListener( 'click', e => e.stopPropagation() );
            Emitter.on('click-outside', () => {
                if( this.isOpen ) this.el.click();
            } );
        }
    }
}
